var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8838 7V25",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25977 20.8988C3.25972 20.6684 3.34486 20.4451 3.50075 20.2667C3.65665 20.0883 3.87371 19.9658 4.11514 19.92C5.08122 19.7354 5.94948 19.2445 6.57304 18.5302C7.1966 17.8159 7.53719 16.9221 7.53719 16C7.53719 15.0779 7.1966 14.1841 6.57304 13.4698C5.94948 12.7555 5.08122 12.2646 4.11514 12.08C3.87371 12.0342 3.65665 11.9117 3.50075 11.7333C3.34486 11.5549 3.25972 11.3316 3.25977 11.1012V8C3.25977 7.73478 3.37243 7.48043 3.57297 7.29289C3.77352 7.10536 4.04551 7 4.32912 7H29.9936C30.2772 7 30.5492 7.10536 30.7498 7.29289C30.9503 7.48043 31.063 7.73478 31.063 8V11.1012C31.063 11.3316 30.9779 11.5549 30.822 11.7333C30.6661 11.9117 30.4491 12.0342 30.2076 12.08C29.2415 12.2646 28.3733 12.7555 27.7497 13.4698C27.1262 14.1841 26.7856 15.0779 26.7856 16C26.7856 16.9221 27.1262 17.8159 27.7497 18.5302C28.3733 19.2445 29.2415 19.7354 30.2076 19.92C30.4491 19.9658 30.6661 20.0883 30.822 20.2667C30.9779 20.4451 31.063 20.6684 31.063 20.8988V24C31.063 24.2652 30.9503 24.5196 30.7498 24.7071C30.5492 24.8946 30.2772 25 29.9936 25H4.32912C4.04551 25 3.77352 24.8946 3.57297 24.7071C3.37243 24.5196 3.25977 24.2652 3.25977 24V20.8988Z",
    stroke: "#20996B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketicon);
export default __webpack_public_path__ + "static/media/ticketicon.fb61fb76dc34ed2561a535c9c44a0ed0.svg";
export { ForwardRef as ReactComponent };